<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="container">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Ordered From Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>Ordered To Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-3">
        <mat-label>Delivery Month <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select class="main-border-class" [(ngModel)]="selected_month">
          <mat-option *ngFor="let month of month_list_for_last_12_months" [value]=month>
            {{month['month_in_string']}} - {{month['year']}}
          </mat-option>
        </mat-select>
      </div>

    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Order Type <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select [(ngModel)]="selected_order_type" class="main-border-class">
          <mat-option value="online">Online</mat-option>
          <mat-option value="portal">Portal</mat-option>
        </mat-select>
      </div>
      <div class="col-3">

        <mat-label>Report Type <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <mat-select [(ngModel)]="selected_report_type" class="main-border-class">
          <mat-option value="zone_wise">Zone Wise</mat-option>
          <mat-option value="booth_wise">Booth Wise</mat-option>
          <mat-option value="route_wise">Route Wise</mat-option>

        </mat-select>
      </div>
      <div class="col-3" *ngIf="selected_report_type == 'zone_wise'">
        <mat-label>Select Zone</mat-label>
        <mat-select [(ngModel)]="selected_zone_id" class="main-border-class">
          <mat-option [value]="zone.id" *ngFor="let zone of zones">{{zone['name']}}</mat-option>
        </mat-select>
      </div>
      <div class="col-3" *ngIf="selected_report_type == 'route_wise'">
        <mat-label>Select Route</mat-label>
        <mat-select [(ngModel)]="selected_route_id" class="main-border-class">
          <mat-option [value]="route.id" *ngFor="let route of mor_routes">{{route['name'] | slice : 0:-4}}</mat-option>
        </mat-select>
      </div>
      <div class="col-3" *ngIf="selected_report_type == 'booth_wise'">
        <mat-label>Enter Booth Code</mat-label>
        <input [(ngModel)]="entered_booth_code" class="main-border-class" type="number" />
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-3"></div> -->
      <div class="col ">
        <button (click)="getClicked()"
        style="font-size: 27px;margin-top: 4%;border-radius: 5px;background: blanchedalmond;margin-left:35%"
        [disabled]="to_date == null || from_date == null || selected_report_type == null || selected_order_type == null || selected_month == null">Get</button>
      </div>
      <!-- <div class="col-3"></div> -->
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="is_pdf_available">
      <div class="col-12" style="text-align: right;">
        <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
            picture_as_pdf
          </i> Download Combined Card</button>
      </div>
    </div><br>
    <div class="row" *ngIf="is_pdf_available">
      <table class="table table-bordered table-hover">
        <thead style="background: bisque;">
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Booth Code</th>
            <th>Customer Code</th>
            <th>Milk Card Number</th>
            <th>Month</th>
            <th>Amount</th>
            <!-- <th>Ordered@</th> -->
            <th>Ordered By</th>
            <th>Customer Card</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let customer_id of customer_data['customer_ids'];  let customer_index=index ">
            <td>{{ customer_index + 1 }}</td>
            <td>{{ customer_data['data_dict'][customer_id]['customer_name'] }}</td>
            <td>{{ customer_data['data_dict'][customer_id]['booth'] }}</td>
            <td>{{ customer_data['data_dict'][customer_id]['customer_id'] }}</td>
            <td>{{ customer_data['data_dict'][customer_id]['card_no'] }}</td>
            <td>{{ monthNames[customer_data['data_dict'][customer_id]['month'] - 1] }}</td>
            <td>{{ customer_data['data_dict'][customer_id]['amount'] | currency: 'INR'}}</td>
            <!-- <td>{{ customer_data['data_dict'][customer_id]['time_created'] | date: 'short'}}</td> -->
            <td>{{ customer_data['data_dict'][customer_id]['order_placed_by'] }}</td>
            <td><button mat-button class="button-class"
                (click)="customerCardClikced(customer_data['data_dict'][customer_id])">Card</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</section>
